import { Checkbox, FormControlLabel } from "@material-ui/core";
import { ChangeEvent, CSSProperties } from "react";

interface RxCheckBoxProps {
	id?: string;
	outId?: string;
	name?: string;
	outName?: string;
	label?: string;
	onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
	outOnChange?: (event: ChangeEvent<{}>, checked: boolean) => void;
	style?: CSSProperties;
	checked?: boolean;
	value?: any;
	className?: string;
}

const RxCheckBox = (props: RxCheckBoxProps) => {
	return (
		<FormControlLabel
			style={props.style}
			control={
				<Checkbox
					id={props.id}
					name={props.name}
					checked={props.checked}
					onChange={props.onChange}
					value={props.value}
				/>
			}
			label={props.label}
			id={props.outId}
			name={props.outName}
			onChange={props.outOnChange}
			className={props.className}
		/>
	);
};

export default RxCheckBox;
